import React from 'react'
import Hero from '../sections/hero/Hero'
import Audiobook from '../sections/audiobook/Audiobook'
import Author from '../sections/author/Author'
import Contact from '../sections/contact/Contact'
import Footer from '../sections/footer/Footer'

const HomePage: React.FC = () => (
  <>
    <Hero />
    <Audiobook />
    <Author />
    <Contact />
    <Footer />
  </>
)

export default HomePage
